import { render, staticRenderFns } from "./PlacementHint.vue?vue&type=template&id=6b63e30f"
import script from "./PlacementHint.vue?vue&type=script&lang=js"
export * from "./PlacementHint.vue?vue&type=script&lang=js"
import style0 from "./PlacementHint.vue?vue&type=style&index=0&id=6b63e30f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports